import { styled } from "@mui/material";
import { ActionsIcon } from "@common/Icons";
import { colors, fonts } from "@constants/cssVariables";

export const UnavailableMessageContainer = styled("div")(({ theme }) => ({
  height: 48,
  display: "flex",
  padding: theme.spacing(4),
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "row",
  borderRadius: 6,
  background: colors.neutral80,
  color: colors.neutral0,
  gap: theme.spacing(3),
  marginTop: theme.spacing(4),
  [theme.breakpoints.up("md")]: {
    marginTop: 0,
    marginBottom: theme.spacing(6),
  },
}));

export const UnavailableMessage = styled("span")(({ theme }) => ({
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 1,
  overflow: "hidden",
  textOverflow: "ellipsis",
  font: fonts.bodyMediumStrong,
}));

export const UnavailableIcon = styled(ActionsIcon)(({ theme }) => ({
  svg: {
    verticalAlign: "middle",
  },
}));
